import { authHeader } from '@/_helpers';

export const crmService = {
  authorize,
  getConfig,
  getConfigByCampaign,
  getCustomFields,
  getCustomFieldsValues,
  setCustomFields,
  getPipelines,
  getStages,
  deactivate,
  getContactSent,
  getUsers,
  getQueue
};

const apiUrl = process.env.VUE_APP_ROOT_API;

function authorize(code, crm_config_type_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ code, crm_config_type_id })
  };
  return fetch(`${apiUrl}/crm/authorize`, requestOptions)
    .then(handleResponse);
}

function getConfig(campaign_id, crm_user_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ campaign_id, crm_user_id })
  };
  return fetch(`${apiUrl}/crm/get-config`, requestOptions)
    .then(handleResponse);
}


function getContactSent() {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({})
  };
  return fetch(`${apiUrl}/crm/contactssent`, requestOptions)
    .then(handleResponse);
}

function getConfigByCampaign(campaign_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ campaign_id })
  };
  return fetch(`${apiUrl}/crm/get-account`, requestOptions)
    .then(handleResponse);
}

function getCustomFields() {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
     body: JSON.stringify({})
  };
  return fetch(`${apiUrl}/crm/get-customfields`, requestOptions).then(handleResponse);
}

function getCustomFieldsValues() {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
     body: JSON.stringify({})
  };
  return fetch(`${apiUrl}/crm/get-customfieldsvalues`, requestOptions).then(handleResponse);
}

function setCustomFields(custom_fields, crm_config) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
     body: JSON.stringify({custom_fields, crm_config})
  };
  return fetch(`${apiUrl}/crm/set-customfields`, requestOptions)
    .then(handleResponse);
}

function getPipelines(campaign_id, crm_user_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ campaign_id, crm_user_id})
  };
  return fetch(`${apiUrl}/crm/get-pipelines`, requestOptions)
    .then(handleResponse);
}

function getStages(campaign_id, crm_user_id, pipeline_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ campaign_id, crm_user_id, pipeline_id })
  };
  return fetch(`${apiUrl}/crm/get-stages`, requestOptions)
    .then(handleResponse);
}

function deactivate() {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader('application/json'),
  };
  return fetch(`${apiUrl}/crm/`, requestOptions)
    .then(handleResponse);
}

function getUsers(campaign_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ campaign_id })
  };
  return fetch(`${apiUrl}/crm/get-users`, requestOptions)
    .then(handleResponse);
}

function getQueue() {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({})
  };
  return fetch(`${apiUrl}/crm/get-queue`, requestOptions)
    .then(handleResponse);
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        logout();
      }

      const error = data || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });

  
}